module.exports = __webpack_public_path__ + "static/media/undraw_warning_re_eoyh.ce2c6fad.svg";